import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { EnquiryLandingViewComponent } from '@vivli/features/enquiry/components';
import { EnquiresFeature } from '@vivli/features/enquiry/feature';

export const EnquiriesEntryWrapper = () => {
    const { user } = useActiveUserContext();

    if (!user) {
        return <EnquiryLandingViewComponent />;
    } else {
        return <EnquiresFeature />;
    }
};
